import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { detectIE } from '../../modules/detect-ie';
import './lines.scss';

class Lines extends Component {
  constructor() {
    super();
    this.svg = null;
    this.container = null;
  }

  clearLines() {
    if (!this.svg || !this.svg.firstChild) return null;
    while (this.svg.firstChild) {
      this.svg.removeChild(this.svg.firstChild);
    }
  }

  componentDidUpdate() {
    if (!this.props.lines || !this.props.container) {
      this.clearLines();
      return null;
    }
    this.svg = findDOMNode(this);
    this.container = findDOMNode(this.props.container);
    this.clearLines();
    this.props.lines.forEach((line, index) => {
      this.renderLines(this.svg, line.from, line.to, index);
    });
  }

  linearScale(opts) {
    var istart = opts.domain[0],
      istop = opts.domain[1],
      ostart = opts.range[0],
      ostop = opts.range[1];
    return function scale(value) {
      return ostart + (ostop - ostart) * ((value - istart) / (istop - istart));
    };
  }

  getSVGPosFromScreenPos([x, y]) {
    const svg = this.svg;
    let position;
    if (svg.createSVGPoint) {
      let point = svg.createSVGPoint();
      point.x = x;
      point.y = y;
      position = point.matrixTransform(svg.getScreenCTM().inverse());
    } else {
      const svgRect = svg.getBoundingClientRect();
      position = {
        x: x - svgRect.left - svgRect.clientLeft,
        y: y - svgRect.top - svgRect.clientTop,
      };
    }
    return position;
  }

  getDirection(fromRect, toRect) {
    if (fromRect.left > toRect.right) {
      return 'left';
    } else if (fromRect.right < toRect.left) {
      return 'right';
    } else if (fromRect.top > toRect.bottom) {
      return 'top';
    } else return 'bottom';
  }

  getFromCoords(fromRect, direction) {
    return [
      fromRect.left + fromRect.width / 2,
      fromRect.top + fromRect.width / 2,
    ];
  }

  getToCoords(toRect, direction) {
    switch (direction) {
      case 'bottom':
        return [toRect.left + toRect.width / 2, toRect.top];
      case 'left':
        return [toRect.right, toRect.top + toRect.height / 2];
      case 'top':
        return [toRect.left + toRect.width / 2, toRect.bottom];
      case 'right':
        return [toRect.left, toRect.top + toRect.height / 2];
      default:
        return [toRect.left + toRect.width / 2, toRect.top];
    }
  }

  getVectorLength(fromPos, toPos) {
    const a = Math.abs(toPos.y - fromPos.y);
    const b = Math.abs(toPos.x - fromPos.x);
    return Math.sqrt(a * a + b * b);
  }

  renderPath(from, to) {
    const directionFlag = from.x > to.x ? 0 : 1;
    return `M${from.x} ${from.y} A 500 500, 0, 0, ${directionFlag}, ${to.x} ${to.y}`;
  }

  renderLines(el, fromRef, toRef, index) {
    const fromRect = this.container
      .querySelector(fromRef)
      .getBoundingClientRect();
    const toRect = this.container.querySelector(toRef).getBoundingClientRect();

    const direction = this.getDirection(fromRect, toRect);
    const coords = {
      from: this.getFromCoords(fromRect, direction),
      to: this.getToCoords(toRect, direction),
    };

    const fromPos = this.getSVGPosFromScreenPos(coords.from);
    const toPos = this.getSVGPosFromScreenPos(coords.to);
    const vectorLength = this.getVectorLength(fromPos, toPos);

    const path = this.renderPath(fromPos, toPos);

    const mask = document.createElementNS('http://www.w3.org/2000/svg', 'mask');
    mask.setAttribute('id', 'mask' + index);

    const maskRect = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'rect'
    );
    maskRect.setAttribute('fill', 'white');
    maskRect.setAttribute('width', '100%');
    maskRect.setAttribute('height', '100%');
    maskRect.setAttribute('x', '0');
    maskRect.setAttribute('y', '0');
    mask.appendChild(maskRect);

    const maskPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    ); //Create a path in SVG's namespace
    maskPath.setAttribute('d', path);
    maskPath.setAttribute('fill', 'none');
    maskPath.setAttribute('stroke', 'black');
    maskPath.setAttribute('stroke-width', 4);
    maskPath.setAttribute('stroke-dasharray', '5 5');
    mask.appendChild(maskPath);
    el.appendChild(mask);

    const newPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    ); //Create a path in SVG's namespace
    newPath.setAttribute('d', path);
    newPath.setAttribute('fill', 'none');
    newPath.setAttribute('stroke', 'black');
    newPath.setAttribute('stroke-width', 2);
    newPath.setAttribute('stroke-dasharray', vectorLength * 1.2);
    if (detectIE() === false) {
      /* IF not IE */
      newPath.setAttribute('stroke-dashoffset', vectorLength * 1.2);
    }
    newPath.setAttribute('class', 'animatePath');
    newPath.setAttribute('mask', `url(#mask${index})`);
    el.appendChild(newPath);
  }

  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="backgroundSVG"
        id="svg-lines"
      />
    );
  }
}

export default Lines;



// WEBPACK FOOTER //
// ./src/components/lines/lines.js